export enum FIELD_NAMES {
  customerSignature = 'customerSignature',
  epsonSignature = 'epsonSignature',
  termsRead = 'termsRead',
}
